import { define } from "@/components/builder/utils"

function BlockHelperPreview({ children }) {
  return children
}

function BlockHelperHTML({ helper, parameters = [], type = 'block', children }) {
  parameters = parameters.map(([param, value]) => value !== undefined ? `${param}=${value}` : param).join(' ')

  switch (type) {
    case 'block':
      return <>
        {`{{#${helper} ${parameters}}}`}
        {children}
        {`{{/${helper}}}`}
      </>
    case 'hook':
      return `{{${helper} ${parameters}}}`
    case 'hook-escape':
      return `{{{${helper} ${parameters}}}}`
    default:
      return <>
        {'<!-- not recognized type -->'}
      </>
  }
}

export default define('block-helper', BlockHelperPreview, BlockHelperHTML)
  .build()
